import { makeStyles } from '@mui/styles';

export const useAreaChartStyles = makeStyles(() => ({
  wrapper: {
    width: '100%',
    position: 'relative'
  },
  loading: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-50px',
    marginLeft: '-50px'
  }
}));
